import React from 'react';
import { Button, Tooltip } from 'antd';
import { AccessControlDevice } from '../../../DTOS/AccessControlDevice/Response/AccessControlDevice';
import { EditOutlined} from '@ant-design/icons';

export const AccessControlDeviceColumn = (
  handleEdit: (record: AccessControlDevice) => void
) => [
  {
    title: 'Device Id',
    dataIndex: 'id',
    key: 'id',
    hidden: true,
  },
  {
    title: 'Nume',
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: 'Referinta Camera',
    dataIndex: 'cameraReference',
    key: 'cameraReference',
  },
  {
    title: 'Referinta Port',
    dataIndex: 'portReference',
    key: 'portReference',
  },
  {
    title: 'Actiune',
    key: 'actions',
    render: (record: AccessControlDevice) => (
      <Tooltip title='Modifica'>
      <Button onClick={() => handleEdit(record)} icon={<EditOutlined/>}></Button>
      </Tooltip>
    ),
    width: 120,
    fixed: 'right'
  },
];
